import * as angular from "angular";
import {IController} from "angular";

import {LogisticsVehicle} from "../../models/logistics-vehicle.model";
import {LogisticsVehicleService} from "../../services/logistics-vehicle-service.service";
import {LogisticsVehiclesDialogsService} from "../../services/logistics-vehicles-dialogs-service.service";
import {ExportType} from "../../../commons/types/export.type";
import {LogisticsVehicleExportQueryModel} from "../../models/logistics-vehicle-export-query.model";
import {LogisticsVehicleStatusType} from "../../types/logistics-vehicle-status.type";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import * as _ from "lodash";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {LOGISTICS_VEHICLES_IMPORT_CONFIG} from "../../constants/logistics-vehicles-import.const";

export class LogisticsVehiclesListViewCtrl implements IController {

  query: string;
  vehicleTypeIds: string[];
  vehicleTypes: VehicleType[];
  branchIds: string[];
  status: LogisticsVehicleStatusType;
  selectedQuickFilterId: string;

  public infiniteScroll: any;
  public pageName: string;
  public filtersConfig: any;
  public importPermissions: string[] = LOGISTICS_VEHICLES_IMPORT_CONFIG.permissions;
  private logisticsVehiclesRef: any;
  private loadLimit: number;
  private exportType: any;

  constructor(private logisticsVehiclesDialogsService: LogisticsVehiclesDialogsService, private $state,
              private $stateParams, private logisticsVehicleService: LogisticsVehicleService,
              private $infiniteScroll, private $logisticsVehicle, private $log, private quickFilterContextService: QuickFilterContextService,
              private viewFilterSettingsService: ViewFilterSettingsService, private confirmDialogService: ConfirmDialogService) {
    this.exportType = ExportType;
    this.pageName = $state.current.name;
  }


  $onInit() {
    this.loadLimit = 50;
    this.filtersConfig = {
      queryString: this.query,
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.vehicleTypeIds,
        SiteFiltersType.vehicleTypes,
        SiteFiltersType.logisticsVehicleStatus
      ],
      bringozFilters: {
        [SiteFiltersType.vehicleTypes]: this.vehicleTypes || [],
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.vehicleTypeIds]: this.vehicleTypeIds || [],
        [SiteFiltersType.logisticsVehicleStatus]: this.status
      },
    }

    this.logisticsVehiclesRef = this.$logisticsVehicle();


    this.logisticsVehiclesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.logisticsVehiclesRef, this.loadLimit, {getFullData: true});
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);

    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.filtersConfig.bringozFilters = filters;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    this._setStateParams();
    this._query();
  }

  onUploadVehiclesClicked() {
    this.$state.go('logistics-vehicles-upload');
  }

  onAddNewVehicleClicked(event) {
    this.logisticsVehiclesDialogsService.createVehicle(event)
      .then((logisticsVehicle: LogisticsVehicle) => {
        return this.logisticsVehicleService.createLogisticsVehicle(logisticsVehicle);
      })
      .then((createdLogisticVehicle) => {
        this.$state.go('logistics-vehicle.vehicle-profile', {id: createdLogisticVehicle.id});
      });
  }

  onUnbindVehicle(currentAgentId: string) {
    this.confirmDialogService.confirm('Unbind Vehicle', 'Are you sure you want to unbind this vehicle?')
      .then(() => {
        this._unbindVehicle(currentAgentId);
      })
      .catch(() => {
      })
  }

  onDeleteLogisticsVehicle(logisticVehicle: LogisticsVehicle) {
    this.logisticsVehicleService.getVehicleResources(logisticVehicle.id)
      .then((res: any) => {
        this.logisticsVehiclesDialogsService.deleteVehicleConfirmDialog(logisticVehicle, res.resourceAllocations, res.agents)
          .then(() => {
            this.deleteLogisticVehicle(logisticVehicle.id);
          })
      })
  }

  onViewLogisticsVehicleClicked(logisticsVehicleId) {
    this.$state.go('logistics-vehicle.vehicle-profile', {id: logisticsVehicleId});
  }

  submitQuery(queryString) {
    this.filtersConfig.queryString = queryString;
    this._query();
  }

  onExport($event, exportType: ExportType) {
    const query: LogisticsVehicleExportQueryModel = {
      type: exportType,
      vehicleTypes: this.filtersConfig.bringozFilters.vehicleTypes,
      vehicleTypeIds: this.filtersConfig.bringozFilters.vehicleTypeIds,
      status: this.filtersConfig.bringozFilters.logisticsVehicleStatus,
      branchIds: this.filtersConfig.bringozFilters.branchIds
    }

    this.logisticsVehicleService.exportLogisticsVehicles(query);
  }

  // ******************************
  //        Private methods
  // ******************************

  private deleteLogisticVehicle(logisticVehicleId) {
    this.logisticsVehicleService.deleteLogisticsVehicles(logisticVehicleId)
      .then(() => {
        this._query();
      });
  }

  private _unbindVehicle(currentAgentId: string) {
    this.logisticsVehicleService.unbindVehicle(currentAgentId)
      .then((updateVehicles) => {
        this.infiniteScroll.removeItems(updateVehicles);
        this.infiniteScroll.addItems(updateVehicles);
      });
  }

  private _query() {
    this.logisticsVehiclesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }


  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.filtersConfig.queryString,
      vehicleTypes: this.filtersConfig.bringozFilters.vehicleTypes,
      vehicleTypeIds: this.filtersConfig.bringozFilters.vehicleTypeIds,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      status: this.filtersConfig.bringozFilters.logisticsVehicleStatus
    };

    // @QueryParam("siteId") String siteId,
    //   @QueryParam("ids") List<String> vehicleIds,
    //   @QueryParam("isStandAlone") Boolean isStandAlone,
    //   @QueryParam("vehicleTypes") List<VehicleType> vehicleTypeList,
    //   @QueryParam("vehicleTypeIds") List<String> vehicleTypeIds,
    //   @QueryParam("status") List<VehicleStatus> vehicleStatuses,
    //   @QueryParam("branchIds") List<String> branchIds,
    //   @QueryParam("query") String searchTerm,
    //   @QueryParam("cursor") String cursor,
    //   @QueryParam("limit") @DefaultValue("100") int limit) {
  }

  private _setStateParams() {
    this.$state.go('.', {
      query: this.filtersConfig.queryString,
      vehicleTypes: this.filtersConfig.bringozFilters.vehicleTypes,
      vehicleTypeIds: this.filtersConfig.bringozFilters.vehicleTypeIds,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      status: this.filtersConfig.bringozFilters.logisticsVehicleStatus,
      selectedQuickFilterId: this.selectedQuickFilterId
    }, {notify: false, reload: false});
  }

}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehiclesListView', {
    bindings: {
      query: '<?',
      vehicleTypes: '<?',
      vehicleTypeIds: '<?',
      branchIds: '<?',
      status: '<?',
      selectedQuickFilterId: '<?'
    },
    template: require('./logistics-vehicles-list-view.html').default,
    controller: LogisticsVehiclesListViewCtrl
  });
